{
  "form": {
    "coApplicant": {
      "label": "Do you have a co-applicant?",
      "error": "Check co-applicant"
    },
    "primaryIncome": {
      "label": "Your monthly income after taxes",
      "error": "Check your monthly income",
      "tooltip": "Your regular monthly income after taxes, for example salary, pension or child support payments. Do not include irregular income, such as bonuses or overtime pay."
    },
    "secondaryIncome": {
      "label": "Your co-applicant’s monthly income after taxes",
      "error": "Check your co-applicant's monthly income"
    },
    "maritalStatus": {
      "label": "What is your marital status?",
      "error": "Check marital status",
      "tooltip": "If you are moving in with another person, select /“Cohabitation/”. If you are divorced, moving to a new apartment due to divorce or legal separation, select /“Unmarried/”.",
      "options": {
        "cohabitant": "Cohabitant",
        "married": "Marriage or registered partnership",
        "single": "Single",
        "widow": "Widow"
      }
    },
    "children": {
      "label": "How many children live in your household?",
      "error": "Check number of children"
    },
    "cars": {
      "label": "How many cars are there in your household?",
      "error": "Check number of cars",
      "tooltip": "Exclude unlimited company car benefit."
    },
    "followingQuestion": {
      "label": "Do you have any of the following?",
      "tooltip": {
        "properties": [
          {
            "introText": "The"
          },
          {
            "categoryName": "Properties"
          },
          {
            "categoryDescription": "category covers apartments or real estate that you intend to keep, such as investment or leisure properties with remaining debt."
          }
        ],
        "otherLoans": [
          {
            "introText": "The"
          },
          {
            "categoryName": "Other loan"
          },
          {
            "categoryDescription": "category covers one-time loans such as loans for a vehicle purchase, renovation, vacation or living in general."
          }
        ],
        "credit": [
          {
            "introText": "The"
          },
          {
            "categoryName": "Credit/credit card"
          },
          {
            "categoryDescription": "category covers revolving consumer credits and credit cards with a granted limit, allowing repeated use for smaller purchases."
          }
        ]
      }
    },
    "propertiesToSell": {
      "label": "Properties that you are not going to sell"
    },
    "loansRemainingBalance": {
      "label": "Remaining debt of housing loans",
      "error": "Check remaining debt",
      "tooltip": "The remaining total debt amount of the loans for all properties you are not planning to sell."
    },
    "housingCompanyDebt": {
      "label": "Remaining balance of the housing company debt",
      "error": "Check remaining housing company debt",
      "tooltip": "The total housing company debt for properties you are not going to sell. Input '0' if you plan to pay off the debt with a new loan or if there is no existing debt."
    },
    "otherLoans": {
      "label": "Other loans"
    },
    "personalLoansBalance": {
      "label": "Total remaining debt of other loans",
      "error": "Check remaining debt",
      "tooltip": "The Other loan category covers one-time loans such as loans for a vehicle purchase, renovation, vacation or living in general."
    },
    "creditCards": {
      "label": "Credits/credit cards"
    },
    "creditCardsLimit": {
      "label": "Maximum credit limit",
      "error": "Check maximum credit limit",
      "tooltip": "Enter the maximum credit limit available to you. For instance, if your granted credit limit is {{creditLimit}} and you've used {{usedAmount}}, input {{creditLimit}} here."
    },
    "submit": "Calculate"
  },
  "loading": "Loading...",
  "yes": "Yes",
  "no": "No",
  "help": "help",
  "years": "years",
  "button": {
    "applyForLoan": "Start your loan application"
  },
  "tips": {
    "heading": "Tips for Using Our Affordability Calculator",
    "subHeading": "To better estimate your eligible loan amount, please accurately input your data and explore various financial scenarios."
  },
  "results": {
    "preliminaryBorrow": {
      "heading": "You can preliminarily borrow",
      "subHeading": "Start your loan application early, even if you're still considering your options. This ensures smooth processing and allows you to receive a preliminary response. It's free and non-binding, with no obligation.",
      "link": "https://danskebank.fi/lainat/hakemus?lang=en"
    },
    "donutChart": {
      "heading": "Example calculation of monthly loan costs",
      "monthlyInstallment": "Monthly installment",
      "amortization": {
        "label": "Amortisation",
        "tooltip": "Amortisation represents the portion of your loan payment that reduces the principal balance of your loan"
      },
      "interestPayment": {
        "label": "Interest payment"
      },
      "loanAmount": {
        "label": "Loan amount"
      },
      "maturity": {
        "label": "Maturity",
        "tooltip": {
          "text": "The typical housing loan maturity is 20 to 30 years. You can experiment with different loan maturities to understand their impact on the monthly installments and the total cost of the debt using our loan cost calculator.",
          "link": "Go to our loan monthly cost calculator",
          "url": "https://danskebank.fi/en/for-you/products/loans/loan-calculator"
        }
      },
      "interestRate": {
        "label": "Interest rate",
        "tooltip": {
          "label": "The example rate for the loan is calculated with interest data on {{date}}. The interest rate on the loan may vary. You can explore different maturity, rates, and repayment methods with our loan monthly cost calculator.",
          "link": "Go to our loan monthly cost calculator"
        }
      }
    },
    "loanAdjust": {
      "heading": "Adjust the loan amount",
      "subHeading": "Estimate different monthly loan costs",
      "label": "Preliminary maximum"
    },
    "footer": {
      "label": "You can further explore different maturities, rates, and repayment methods with our loan cost calculator.",
      "ctaButton": "Go to our loan cost calculator"
    },
    "error": {
      "heading": "Oh no, the calculation failed",
      "subHeading": "It might help to go back and try again. If this continues to happen, please call us at 0752 - 48 45 42."
    }
  },
  "moreInformation": {
    "heading": "Additional information",
    "howWeCalculate": {
      "title": "How we calculate",
      "paragraph1": "Based on the information you provided, we have evaluated your ability to pay, which affects how much loan you could get. The estimation is based on statistical living costs. In the loan repayment we have taken into account a possible increase in the interest rate.",
      "paragraph2": "The calculation does not consider the personal funds and collateral required for the loan. Typically, your own savings and additional collateral constitute around 20-30% of the purchase price, while the property being purchased serves as collateral for the remaining loan amount."
    },
    "thingsToConsider": {
      "title": "Other things to consider",
      "paragraph1": "Obtaining a loan is influenced not only by your repayment ability but also by the collateral required. In major cities, a housing loan is secured by the property being purchased covering up to 70-80% of the debt-free purchase price.",
      "paragraph2": "The amount of the loan granted for the first home can be no more than 95% of the debt-free purchase price of the property to be purchased. The first-time home buyer must therefore have at least 5% of their own savings or other collateral. Additional collateral is often provided through a paid loan guarantee from an insurance company, a government-backed additional guarantee, or, for instance, the parents' apartment or other property.",
      "paragraph3": {
        "mortgageInfo": "Start your ",
        "loanApplication": "loan application",
        "followUp": " early, even if you're still weighing your options. This ensures smooth processing and allows you to receive a preliminary response. It's free and non-binding, with no obligation.",
        "loanApplicationUrl": "https://danskebank.fi/lainat/hakemus?lang=en"
      }
    }
  },
  "legalText": {
    "paragraph1": " Granting a loan always requires an approved credit decision. In order to make a credit decision, Danske Bank checks the customer's personal credit information from Suomen Asiakastieto Oy. In addition to this, in order to process the credit application, we can retrieve and process your information from the Positive Credit Information Register. The loan interest rate and other conditions are detailed in the loan offer. Request your own offer from Danske Bank.",
    "paragraph2": "Example of a home loan: If the customer takes out a home loan of 170,000 euros, where the loan term would be 25 years and the reference interest rate for the loan is the 12-month euribor rate, the total interest rate on the loan would be 4.278% (the effective annual interest rate calculated according to the Consumer Protection Act is 4.452%). The total amount of the credit and other credit costs is 280,765.04 euros, including the arrangement fee of 1,020 euros and the automatic account debit payment of 2.70 euros/payment installment. The number of installments is 300. Example calculated on 25.07.2024 with interest data."
  }
}
